import { SegmentedControlOption } from '@grubhubprod/gh-cookbook-react';
import { DropdownOptionProps } from 'src/components/CookbookSelectWrapper/CookbookSelectWrapper';
import { LocTagInvite } from 'src/types/LineOfCredit';
import { IGroup } from 'src/utilities/useSearchHooks';

export enum FulfillmentTypeSegmentedValues {
  DELIVERY = 'Delivery',
  PICKUP = 'Pickup',
  ALL = 'Both',
}

export enum TimeIntervalTypeValues {
  ALL_DAY = 'ALL_DAY',
  HOURS = 'HOURS',
  OVERNIGHT = 'OVERNIGHT',
}

export enum CreditTypeValues {
  SINGLE = 'single',
  REPEATS = 'repeats',
}

export enum ExpiresOn {
  ON_THIS_DAY = 'ON THIS DAY',
  NEVER = 'NEVER',
}

export enum MonthAvailability {
  EVERY_DAY = 'every_day',
  ON_SPECIFIC_DAY = 'on_specific_day',
  WITHIN_DATE_RANGE = 'within_date_range',
}

export const numberWithUpToTwoDecimalsPattern =
  /^\s*\d+(\.\d{1,2})?\s*$|^\s*\.\d{1,2}\s*$/;

export const fulfillmentTypeOptions: SegmentedControlOption[] = [
  {
    id: 'delivery',
    label: 'Delivery',
    value: FulfillmentTypeSegmentedValues.DELIVERY,
  },
  {
    id: 'pickup',
    label: 'Pickup',
    value: FulfillmentTypeSegmentedValues.PICKUP,
  },
  {
    id: 'both',
    label: 'Both',
    value: FulfillmentTypeSegmentedValues.ALL,
  },
];

export const timeIntervalTypeOptions: SegmentedControlOption[] = [
  {
    id: TimeIntervalTypeValues.ALL_DAY,
    label: 'All day',
    value: TimeIntervalTypeValues.ALL_DAY,
  },
  {
    id: TimeIntervalTypeValues.HOURS,
    label: 'Hours',
    value: TimeIntervalTypeValues.HOURS,
  },
  {
    id: TimeIntervalTypeValues.OVERNIGHT,
    label: 'Overnight',
    value: TimeIntervalTypeValues.OVERNIGHT,
  },
];

export const selectLocationOptions: SegmentedControlOption[] = [
  { id: 'hasNoLocation', label: 'Any location', value: 'hasNoLocation' },
  { id: 'hasLocation', label: 'Some locations', value: 'hasLocation' },
];

export const creditTypeOptions: SegmentedControlOption[] = [
  {
    id: CreditTypeValues.SINGLE,
    label: 'One-time',
    value: CreditTypeValues.SINGLE,
  },
  {
    id: CreditTypeValues.REPEATS,
    label: 'Recurring',
    value: CreditTypeValues.REPEATS,
  },
];

export const expiresOnOptions: DropdownOptionProps[] = [
  { value: ExpiresOn.NEVER, text: 'No deactivation date' },
  { value: ExpiresOn.ON_THIS_DAY, text: 'On this day' },
];

export function getYesAndNoOptions(id: string): SegmentedControlOption[] {
  return [
    { id: `${id}Yes`, label: 'Yes', value: 'Yes' },
    { id: `${id}No`, label: 'No', value: 'No' },
  ];
}

export function getYesNoOptionalOptions(id: string): SegmentedControlOption[] {
  return [
    ...getYesAndNoOptions(id),
    { id: `${id}Optional`, label: 'Optional', value: 'Optional' },
  ];
}

export function filterGroupSearchResultsCb(
  group: IGroup,
  tagInvites: LocTagInvite[],
  initGroup: LocTagInvite = null
): boolean {
  return tagInvites.every(
    (existingBudget) =>
      existingBudget.id !== group.id || initGroup?.id === existingBudget.id
  );
}
